import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { SnapchatStoryViewerPage } from '../../../pages/tools/creator-tools/SnapchatStoryViewerPage';

export const Route = createFileRoute('/_site/tools/snapchat-story-viewer')({
  head: () => toolHead('snapchat-story-viewer'),
  component: SnapchatStoryViewerPage,
});
